<template>
  <xt-dialog :visible="visible"
             type="alert"
             confirm-text="确认" @confirm="close">
    <div style="text-align: center;margin: 20px 0;">
      {{content}}
    </div>
  </xt-dialog>
</template>
<script>
import XtDialog from "@/components/xtDialog";
export default {
  components: {XtDialog},
  name: 'notice',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    }
  },
  mounted() {

  }
}
</script>
<style>

</style>